import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'arivo-dialog',
  templateUrl: './arivo-dialog.component.html',
  styleUrl: './arivo-dialog.component.scss',
})
export class ArivoDialogComponent {
  @Input() open: boolean = false;
  @Input() dismissible: boolean = true;
  @Output() onDismissed = new EventEmitter<void>();

  backdropClick(event: Event): void {
    if (event.target === event.currentTarget && this.dismissible) {
      this.open = false;
      this.onDismissed.emit();
    }
  }
}
